import {getUrlParameter, removeParamFromUrl} from "./utils/urlHelpers";

let newsletterHash = getUrlParameter("newsletter");
if(newsletterHash) {
    removeParamFromUrl("newsletter");
    $.ajax({
        url: "/newsletter-action/click/" + newsletterHash,
        method: "GET",
        success: function (r) {

        }
    });
}

